export default "__VITE_ASSET__COhOqMC4__"